/**
 * Prints the modal content on button click with class print-button.
 */
export function printContent() {
	const $modals = $( document ).find( '.o__modal-ime' );
	if ( !$modals.length ) {
		return;
	}

	const $head = $( 'head' );
	const $printButtons = $modals.find( '.print-button' );

	$printButtons.on( 'click', function print() {
		// Finds the modal parent container.
		const $modal = $( this ).closest( '.js-modal' );
		const id = $modal.attr( 'id' );

		// Adds the print styles for this modal.
		$head
			.append( `<style type="text/css" media="print" id="print-${id}">
				#${id} .m__modal-content__ime-entry__all-data {
					display: block !important;
				}
				.m__modal-content__ime-entry__all-data-body-block, .m__modal-content__ime-entry__all-data{
					margin: 0px;
					padding: 0px;				
				}
				
				.o__modal-ime-header, .o__footer {
					display: none;
				}
						
				@media print {
					html, body {
						height:100%;
						margin: 0 !important;
						padding: 0 !important;
						overflow: auto;
						border: 0;
					}
					
					img {
						display: none;
					}
				}		
								
				@page {
					margin-top: 0;
					margin-bottom: 0;
				}
				</style>` );

		window.print();

		// Removes the print styles for this modal.
		$modal
			.find( '.o__modal-ime-header-close' )
			.on( 'click', () => {
				$( 'head' )
					.find( `#print-${id}` )
					.remove();
			});
	});
}